import { render } from "./Dashboard3.vue?vue&type=template&id=7da8a6e0"
import script from "./Dashboard3.vue?vue&type=script&lang=js"
export * from "./Dashboard3.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__